import React from 'react'
import Module from '../../layout/Module'
import { Routes, Route } from 'react-router-dom'
import Loading from '../../Loading/Loading'
import useFetchData from '../../../hooks/useFetchData'
import InternalLinks from './InternalLink/InternalLink'
import ExternalDashboard from './ExternalLink/ExternalLink'
import NotFoundPage from '../../NotFoundPage/NotFoundPage'
import { useEffect } from 'react'
import ByStudent from './InternalLink/ByStudent/ByStudent'
import GroupStudents from './InternalLink/GroupStudents/GroupStudents'
import AnalyticsCurriculum from './InternalLink/AnalyticsCurriculum/AnalyticsCurriculum'
import BiDashboard from './BiDashboard/BiDashboard'
import BiChartRenderer from './BiDashboard/BiChartRenderer'
import AiAnalystChat from './BiDashboard/AiAnalystChat'
import BoardViewer from './Boards/BoardViewer'
import BoardBuilder from './Boards/Builder/BoardBuilder'
import { useSelector } from 'react-redux'

const Analytics = () => {
  const { isLoading, data } = useFetchData('setting/analytics-chart')
  const [loading, setLoading] = React.useState(true)
  const userRoles = useSelector((state) => state?.session?.user?.roles || [])
  const isMaestro = userRoles.some((r) => ['Maestro'].includes(r?.name || r?.id))
  // MF-506 — AI Analyst gateado por permiso (módulo 'AI-Analyst' → clave 'ai-analyst'),
  // no por rol hardcodeado: sigue lo que el rol tenga otorgado en la tabla de roles.
  const canAiAnalyst = !!useSelector((state) => state?.session?.permissions?.['ai-analyst'])
  // MF-554 — Board Builder: module BoardsBuilder (license `boards`).
  const canBuildBoards = !!useSelector((state) => state?.session?.permissions?.boardsbuilder)

  useEffect(() => {
    if (!isLoading) {
      setTimeout(() => {
        setLoading(false)
      }, 1500)
    }
  }, [isLoading])

  return (
    <Module moduleName='analytics'>
      <Module.Header title='Analytics' />
      <Module.Body>
        {loading || isLoading || !data ? (
          <Loading />
        ) : (
          <Routes>
            <Route index element={<div></div>} />
            {isMaestro && (
              <Route
                path='bi-dashboard'
                element={
                  <Module.BodyFullContainer>
                    <BiDashboard />
                  </Module.BodyFullContainer>
                }
              />
            )}
            {canAiAnalyst && (
              <Route
                path='ai-analyst'
                element={
                  <Module.BodyFullContainer>
                    <AiAnalystChat />
                  </Module.BodyFullContainer>
                }
              />
            )}
            {canBuildBoards && (
              <Route
                path='board-builder/*'
                element={
                  <Module.BodyFullContainer className='overflow-y-auto'>
                    <BoardBuilder />
                  </Module.BodyFullContainer>
                }
              />
            )}
            {data?.map((item) => {
              // MF-554 — a published Board (Chart Library tiles in a bento grid). Its button is
              // created by the Board Builder; code = "board-<boardCode>".
              if (item.engine === 'canvas') {
                const boardCode = item.data?.boardCode || String(item.code || '').replace(/^board-/, '')
                return (
                  <Route
                    key={`analytics-canvas-${item._id}`}
                    path={item.code}
                    element={
                      <Module.BodyFullContainer className='overflow-y-auto'>
                        <BoardViewer code={boardCode} />
                      </Module.BodyFullContainer>
                    }
                  />
                )
              }
              if (item.engine === 'bi-custom') {
                return (
                  <Route
                    key={`analytics-bi-custom-${item._id}`}
                    path={item.code}
                    element={
                      // MF-534 — el contenedor de altura fija (h-screen-module-body-full-body)
                      // recortaba el contenido alto (ej. la tabla de ítems bajo el scatter de
                      // PatStudentReport/PatItemCohort) sin scroll. overflow-y-auto lo hace
                      // scrollable para TODOS los bi-custom, sin tocar el resto de Analytics.
                      <Module.BodyFullContainer className='overflow-y-auto'>
                        <BiChartRenderer link={item.link} />
                      </Module.BodyFullContainer>
                    }
                  />
                )
              }
              if (item.internal) {
                if (item.link === 'CurriculumLevels') {
                  return (
                    <Route
                      key={`analytics-internal-${item._id}`}
                      path={`${item.code}/*`}
                      Component={ByStudent}
                    />
                  )
                }
                if (item.link === 'StudentsDistribution') {
                  return (
                    <Route
                      key={`analytics-internal-${item._id}`}
                      path={`${item.code}/*`}
                      Component={GroupStudents}
                    />
                  )
                }
                if (item.engine === 'analytics-curriculum') {
                  return (
                    <Route
                      key={`analytics-internal-${item._id}`}
                      path={`${item.code}/analytics-curriculum/*`}
                      Component={AnalyticsCurriculum}
                    />
                  )
                }
                return (
                  <Route
                    key={`analytics-internal-${item._id}`}
                    path={`${item.code}/*`}
                    element={<InternalLinks link={item.link} />}
                  />
                )
              } else {
                return (
                  <Route
                    key={`analytics-external-${item}`}
                    path={item.code}
                    element={
                      <Module.BodyFullContainer>
                        <ExternalDashboard link={item.link} />{' '}
                      </Module.BodyFullContainer>
                    }
                  />
                )
              }
            })}
            <Route
              path='*'
              element={
                <Module.BodyFullContainer>
                  <NotFoundPage />
                </Module.BodyFullContainer>
              }
            />
          </Routes>
        )}
      </Module.Body>
    </Module>
  )
}

export default Analytics
